export const faqs = [
  {
    question: "如何判断自己的穿搭风格？",
    answer: "判断穿搭风格可以从三个方面入手：首先，观察你日常最喜欢穿的单品和最常参考的时尚博主风格；其次，考虑你的职业场景和生活习惯——职场女性可能偏向简约通勤风，自由职业者则更自由多变；最后，尝试建立风格关键词（如「温柔知性」「干练飒爽」「甜美浪漫」），围绕关键词构建你的衣橱。建议从基础款开始尝试，慢慢找到最适合自己的表达方式。",
  },
  {
    question: "日常通勤如何穿出高级感？",
    answer: "日常通勤穿出高级感的关键在于面料、剪裁和配色。选择质感好的天然面料（羊毛、真丝、纯棉），搭配合身剪裁的基础款单品。颜色上以中性色为主——米色、驼色、灰色、黑色、白色是高级感通勤的基础色盘。记住用一件质感配饰（如一只好手表或一副精致耳环）作为造型的点睛之笔，但全身同时佩戴的显眼配饰不要超过三件。",
  },
  {
    question: "小个子女生如何穿出气场？",
    answer: "小个子女生可以通过以下几个技巧增强气场：第一，打造高腰线——高腰裤、高腰裙或将上衣扎进裤子都能拉长腿部比例；第二，选择同色系穿搭或垂直条纹，制造纵向延伸的视觉效果；第三，选择尖头鞋或露脚背的鞋子，延长腿部线条；第四，避免过于宽大或拖沓的单品，合身的剪裁比oversize更适合小个子。记住，气场不是身高决定的，而是自信和品味的外在体现。",
  },
  {
    question: "配饰搭配有哪些基本原则？",
    answer: "配饰搭配有三个核心原则：第一，「三点原则」——同时佩戴的显眼配饰不超过三件；第二，「材质统一」——金属色保持统一（金配金、银配银）；第三，「场合匹配」——日常通勤选择低调精致款，正式场合可选择更有设计感的款式。特别推荐每人都拥有的配饰三件套：一对百搭的金属耳环、一条细项链和一只品质好的手表，这三件几乎可以搭配你衣橱里90%的衣服。",
  },
  {
    question: "如何在预算有限的情况下提升穿搭质感？",
    answer: "预算有限时，建议遵循「二八法则」：将80%的预算投资在经典基础款上（一件好大衣、一双好鞋、一只百搭包），20%用于潮流单品。基础款选择质感更好的，因为使用频率最高；潮流款可以适当选择平价替代。同时，学习利用配饰（丝巾、腰带、首饰）来提升平价单品的精致度——一条丝巾能让一件普通白衬衫瞬间提升好几个档次。另外，保持衣物整洁、熨烫平整，这些细节不需要花钱但能极大提升整体质感。",
  },
  {
    question: "不同场合的穿搭有什么基本原则？",
    answer: "场合穿搭的核心原则是「得体大于惊艳」。职场穿搭以专业、利落为主，避免过于暴露或休闲；约会穿搭可以展现柔美的一面，选择裙装或柔和的色彩；派对穿搭可以更大胆一些，尝试亮片、丝绒等特殊面料；户外活动则要兼顾舒适与时尚，选择透气面料和平底鞋。最重要的是，穿着让你自信的衣服——自信才是最好的配饰。",
  },
  {
    question: "如何建立自己的胶囊衣橱？",
    answer: "建立胶囊衣橱的步骤：第一步，清理现有衣物，只保留质感好、合身且你真正会穿的单品；第二步，确定你的核心色系（建议2-3个中性色+1-2个点缀色）；第三步，配置基础单品——2条好裤子（西裤+牛仔裤）、3-4件上衣（白衬衫+针织衫+T恤）、2件外套（西装+风衣）、2条连衣裙（日常款+场合款）；第四步，确保每件单品至少能搭配出3套造型。一个精心打造的30件胶囊衣橱，可以轻松应对四季的各种场合。",
  },
  {
    question: "穿高跟鞋有什么技巧让脚不那么疼？",
    answer: "穿高跟鞋不疼有几个实用技巧：第一，选择下午去买鞋，因为脚在下午会自然肿胀一些，这时试穿的尺码最合适；第二，新鞋先在家里穿着厚袜子走几天，让鞋自然撑开贴合脚型；第三，选择粗跟或方跟比细跟更稳更舒适，跟高5-7cm是最舒适的区间；第四，在鞋内贴前掌垫和防磨贴，特别是脚掌和脚后跟部位；第五，走路时重心放在前脚掌，步伐放小放慢。如果长时间站立或行走，随身带一双折叠平底鞋备用。",
  },
];